// Import Packages
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

// Import Material UI
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

// Import CSS
import "./ModuleItem.css";

const ModuleItem = ({
    icon,
    title,
    description,
    learnMoreLink,
    count,
    children
}) => {
    const { t } = useTranslation();
    const [expand, setExpand] = useState(false);

    return (
        <div className="module-item-container font-manrope">
            <div className="module-item-padding">
                <div className="ml-item-header module-item-header">
                    <div className="module-item-title-container">

                        <img
                            src={icon}
                            alt=""
                        />
                        <span className="module-item-title">{title}</span>
                        {
                            count &&
                            <div className="module-item-count-container">
                                <span className="module-item-count">{count}</span>
                            </div>
                        }
                    </div>
                    {expand ? <RemoveIcon className="module-item-expand" onClick={() => setExpand(false)} /> : <AddIcon className="module-item-expand" onClick={() => setExpand(true)} />}
                </div>
                <div className="module-item-description">
                    {description}
                </div>
                <div className="module-item-more">
                    <a href={learnMoreLink}>{t("CONTENT.FLOW.LEFT-AREA.LEARN-MORE")}</a>
                </div>

                {
                    expand &&
                    <>
                        <div className="module-item-divider" />

                        <div className="module-item-content">
                            {children}
                        </div>
                    </>
                }
            </div>
        </div>
    )
}

export default ModuleItem;
